import { ReportModel } from "../models/report/ReportModel";
import { TeamModel } from "../models/report/TeamModel";
import { PlayerModel } from "../models/report/PlayerModel";
import { MetricModel } from "../models/report/MetricModel";
import { MatchModel } from "../models/report/MatchModel";

export class ReportHelper {
    private _report: ReportModel;

    constructor(report: ReportModel) {
        this._report = report;
    }

    public getMatch(matchId: string): MatchModel {
        let match: MatchModel = undefined;

        if (matchId)
            match = this._report.matches.find(match => matchId == matchId);
        else if (this._report.matches.length > 0)
            match = this._report.matches[0];

        return match;
    }

    public getSeriesName(): string {

        if (this._report.series)
            return this._report.series.name;
        else
            return null;
    }

    public getSeasonName(): string {

        if (this._report.season)
            return this._report.season.name;
        else
            return null;
    }

    public getTeams(): TeamModel[] {
        let teams = [];

        for (let [index, team] of Object.entries(this._report.teams)) {
            if (team.teamMetaData)
                teams.push(team);
        }

        return teams;
    }

    public getTeamPlayers(teamId: string): PlayerModel[] {
        let players = [];

        for (let [index, player] of Object.entries(this._report.players)) {
            if (player.playerMetaData &&
                player.playerMetaData.matchTeamPlayer &&
                player.playerMetaData.matchTeamPlayer.teamGuid == teamId)
                players.push(player);
        }

        return players;
    }

    public getTeamMetric(teamId: string, metricId: string): MetricModel {
        let teamMetric: MetricModel = undefined;

        for (let [index, team] of Object.entries(this._report.teams)) {
            if (team.teamId == teamId) {
                for (let [index, metric] of Object.entries(team.metrics)) {
                    if (metric.metricId == metricId) {
                        teamMetric = metric;
                        break;
                    }
                }
            }

            if (teamMetric)
                break;
        }

        return teamMetric;
    }

    public getTeamPlayerMetric(teamId: string, playerId: string, metricId: string): MetricModel {
        let playerMetric: MetricModel = undefined;

        for (let [j, player] of Object.entries(this._report.players)) {
            if (player.playerMetaData &&
                player.playerMetaData.matchTeamPlayer &&
                player.playerMetaData.matchTeamPlayer.teamGuid == teamId &&
                (player.playerMetaData.matchTeamPlayer.matchTeamPlayerId == playerId || player.playerId == playerId)) {
                for (let [k, metric] of Object.entries(player.metrics)) {
                    if (metric.metricId == metricId) {
                        playerMetric = metric;
                        break;
                    }
                }

                if (playerMetric)
                    break;
            }
        }

        return playerMetric;
    }

    public getPlayerMetric(playerId: string, metricId: string): MetricModel {
        let playerMetric: MetricModel = undefined;

        for (let [j, player] of Object.entries(this._report.players)) {
            if (player.playerId == playerId) {
                for (let [k, metric] of Object.entries(player.metrics)) {
                    if (metric.metricId == metricId) {
                        playerMetric = metric;
                        break;
                    }
                }

                if (playerMetric)
                    break;
            }
        }

        return playerMetric;
    }

    public getBaseMetric(matchId: string, metricId: string): MetricModel {
        let baseMetric: MetricModel = undefined;

        for (let [index, match] of Object.entries(this._report.matches)) {
            if (match.matchId == matchId) {
                for (let [index, metric] of Object.entries(match.metrics)) {
                    if (metric.metricId == metricId) {
                        baseMetric = metric;
                        break;
                    }
                }
            }

            if (baseMetric)
                return baseMetric;
        }

        for (let [index, metric] of Object.entries(this._report.season.metrics)) {
            if (metric.metricId == metricId) {
                baseMetric = metric;
                break;
            }
        }

        if (baseMetric)
            return baseMetric;

        for (let [index, metric] of Object.entries(this._report.series.metrics)) {
            if (metric.metricId == metricId) {
                baseMetric = metric;
                break;
            }
        }

        if (baseMetric)
            return baseMetric;

        return baseMetric;
    }
}